import { ApiBase } from "@/api/ApiBase";

export interface ConfigurarChavesFeResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

export class ChavesFacturacaoElectronicaApi extends ApiBase {
  configurar(
    chavePrivada: string,
    chavePublica: string,
  ): Promise<ConfigurarChavesFeResponse> {
    return this.http.post<ConfigurarChavesFeResponse>(
      "/api/comerciante/add-chaves-fe",
      { privada: chavePrivada, publica: chavePublica },
    );
  }
}
